import React from "react";

import { queries as basicHealthQueries } from "lib/build/dashboards/basic-health";
import { queries as htxQueries } from "lib/build/dashboards/htx";
import { queries as ktxQueries } from "lib/build/dashboards/ktx";
import { queries as ltxQueries } from "lib/build/dashboards/ltx";
import { queries as sharedQueries } from "lib/build/dashboards/shared";

import { Content } from "src/common/components/Page";
import { FullPagePreloader } from "src/common/components/Preloader";
import { useFetchEvents, useSelectEvents } from "src/features/events";
import { useOrgModParams } from "src/features/orgmod";
import {
	useFetchPatient,
	usePatientIdParam,
	useSelectPatient
} from "src/features/patient";

export const ModuleContent: React.FunctionComponent<
	React.ComponentProps<typeof Content>
> = props => {
	const { mod } = useOrgModParams();
	const patientId = usePatientIdParam();

	const queries = React.useMemo(() => {
		if (mod === "basic_health") {
			return basicHealthQueries;
		}
		if (mod === "htx" || mod === "htx_nm") {
			return htxQueries;
		}
		if (mod === "ktx" || mod === "kd") {
			return ktxQueries;
		}
		if (mod === "ltx") {
			return ltxQueries;
		}
		throw new Error("invalid module");
	}, [mod]);

	useFetchPatient(patientId);

	const fetchEvents = useFetchEvents(patientId);
	React.useEffect(() => {
		fetchEvents(Object.values({ ...sharedQueries, ...queries }));
	}, [fetchEvents, queries]);

	const { isLoading: isLoadingPatient } = useSelectPatient(patientId);
	const { isLoading: isLoadingEvents } = useSelectEvents();

	if (isLoadingPatient || isLoadingEvents) {
		return (
			<Content
				key="module-content--loading"
				body={<FullPagePreloader />}
			/>
		);
	}

	return <Content key={`module-content--${mod}--${patientId}`} {...props} />;
};
